import { UploadCloud } from 'lucide-react'
import { useId } from 'react'

import GradientWrapper from '@/common/GradientWrapper'
import { cn } from '@/theme/utils'
import { UiButton } from '@/ui/UiButton'

export default function UploadZone({
  isDisabled,
  setRawJsonText,
  triggerValidation,
}: {
  isDisabled: boolean
  setRawJsonText: (rawJsonText: string) => void
  triggerValidation: () => Promise<boolean>
}) {
  const inputId = useId()

  const readJsonFile = async (file: File) => {
    if (!file.name.toLowerCase().endsWith('.json')) {
      return
    }

    const text = await file.text()
    setRawJsonText(text)
    await triggerValidation()
  }

  return (
    <GradientWrapper>
      <div
        className={cn(
          'border-border bg-input rounded-lg border p-6 backdrop-blur-sm',
          'flex flex-col items-center justify-center gap-3 text-center',
        )}
      >
        <UploadCloud className='text-muted-foreground size-6' />
        <div className='space-y-1'>
          <p className='text-foreground text-sm font-semibold'>
            Upload a JSON file
          </p>
          <p className='text-muted-foreground text-xs'>
            Only .json is supported
          </p>
        </div>

        <div className='flex items-center gap-3'>
          <input
            id={inputId}
            type='file'
            accept='application/json,.json'
            className='hidden'
            disabled={isDisabled}
            onChange={event => {
              const file = event.target.files?.[0]
              if (!file) return

              void readJsonFile(file)

              event.target.value = ''
            }}
          />

          <UiButton
            type='button'
            variant='outline'
            disabled={isDisabled}
            onClick={() => {
              const input = document.getElementById(inputId)
              if (!(input instanceof HTMLInputElement)) return
              input.click()
            }}
          >
            Choose file
          </UiButton>
        </div>
      </div>
    </GradientWrapper>
  )
}
